function countUp($section) {
  var $countUp = $section.find(".count-up");

  if ($countUp.length) {
    $countUp.each(function () {
      countUpStat($(this));
    });

    $countUp.removeClass("count-up");
  }
}

function countUpStat($number) {

  var step = $number.data("step");
  var currentNumber = parseFloat($number.html());
  var countTo = $number.data("count-to");
  var duration = $number.data("duration");
  var countInterval = duration / (countTo / step);

  var interval = setInterval(function () {
    if (currentNumber >= countTo) clearInterval(interval);

    currentNumber = (currentNumber + step >= countTo) ? countTo : currentNumber + step;

    $number.html(parseFloat(currentNumber).toLocaleString());

  }, countInterval);
}